module.exports = __webpack_public_path__ + "img/img_bjsh_retail@3x.f48d96ba.png";